/**
 * Centre hitmarker. Fires whenever `state.hitmarker.t` changes (~120 ms).
 */
import { el, setClass, setOpacity, setStyle } from './dom.js';

const LIFE = 0.12;

export class HitMarker {
  constructor(parent) {
    const root = el('div', 'cs-hm', parent);
    for (let i = 0; i < 4; i++) el('i', null, root);
    this.root = root;
    this._lastT = 0;
    this._timer = 0;
  }

  update(hm, dt) {
    const t = hm?.t ?? 0;
    if (t !== this._lastT) {
      this._lastT = t;
      // t === 0 is the "nothing has happened yet" sentinel, never a hit.
      this._timer = t ? LIFE : 0;
      if (t) {
        setClass(this.root, 'hs', !!hm.headshot);
        setClass(this.root, 'kill', !!hm.killed);
      }
    }
    if (this._timer > 0) {
      this._timer -= dt;
      if (this._timer <= 0) {
        this._timer = 0;
        setOpacity(this.root, 0);
        setStyle(this.root, 'transform', 'scale(1)');
        return;
      }
      const k = this._timer / LIFE;
      setOpacity(this.root, Math.min(1, 0.35 + k * 0.65));
      setStyle(this.root, 'transform', 'scale(' + (1.28 - 0.28 * k).toFixed(2) + ')');
    }
  }
}
